module.exports = __webpack_public_path__ + "img/Logo-35.c266c901.svg";